import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-start" }
const _hoisted_2 = { class: "d-flex flex-row mt-3" }
const _hoisted_3 = { class: "code-box code-box--with-border" }
const _hoisted_4 = {
  class: "text color--info",
  ref: "generateKeyAndRequest"
}
const _hoisted_5 = {
  class: "alert alert-dismissible alert-warning mt-3",
  role: "alert"
}
const _hoisted_6 = { class: "alert__icon" }
const _hoisted_7 = { class: "d-flex flex-row mt-3" }
const _hoisted_8 = { class: "code-box code-box--with-border" }
const _hoisted_9 = {
  class: "text color--info",
  ref: "checkData"
}
const _hoisted_10 = {
  class: "alert alert-dismissible alert-success mt-3",
  role: "alert"
}
const _hoisted_11 = { class: "alert__icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text mt-4" }, "Comando para gerar a chave e a requisição:", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _cache[4] || (_cache[4] = [
          _createTextVNode("$ openssl req -new -newkey rsa:2048 -keyout "),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "cert1.key -out", -1),
          _createTextVNode(),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "cert1.csr", -1)
        ]), 512)
      ]),
      _createVNode(_component_Icon, {
        class: "ms-3 m-auto",
        id: "copy-generate-key-and-request-icon",
        name: "copy",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doCopy(this.$refs.generateKeyAndRequest, 1))),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetContent(1))),
        style: {"cursor":"pointer"}
      })
    ]),
    _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"text mt-3\">É necessário preencher apenas o <strong>Common Name</strong>:</div><div class=\"code-box mt-3\"><p>Generating a 2048 bit RSA private key<br>...................+++<br> .......................................................+++<br> writing new private key to &#39;cert1.key&#39;<br> Enter PEM pass phrase:<span class=\"red-background\">&lt;informe a senha de proteção da chave privada&gt;<br></span>Verifying - Enter PEM pass phrase:<span class=\"red-background\">&lt;confirme a senha&gt;<br></span>-----<br> You are about to be asked to enter information that will be incorporated<br> into your certificate request.<br> What you are about to enter is what is called a Distinguished Name or a DN.<br> There are quite a few fields but you can leave some blank<br> For some fields there will be a default value,<br> If you enter &#39;.&#39;, the field will be left blank.<br> -----<br> Country Name (2 letter code) []:<span class=\"red-background\"> . </span><br>State or Province Name (full name) []:<span class=\"red-background\"> . </span><br>Locality Name (eg, city) []:<span class=\"red-background\"> . </span><br>Organization Name (eg, company) []:<span class=\"red-background\"> . </span><br>Organizational Unit Name (eg, section) []:<span class=\"red-background\"> . </span><br>Common Name (eg, fully qualified host name) []:<span class=\"red-background\">cert1 <br></span>Email Address []:<span class=\"red-background\"> . </span><br></p><p>Please enter the following &#39;extra&#39; attributes<br>to be sent with your certificate request<br> A challenge password []:<span class=\"red-background\"> . </span><br></p></div>", 2)),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Icon, { name: "circle-info" })
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "alert__content" }, [
        _createElementVNode("div", { class: "text" }, [
          _createElementVNode("strong", null, "Importante"),
          _createTextVNode(": Anote a senha de proteção da chave privada emum local seguro. Não é possível recuperar essa senha posteriormente, e sem ela não será possível utilizar o certificado digital após a emissão.")
        ])
      ], -1))
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "h6 mt-3" }, [
      _createElementVNode("strong", null, "Se quiser verificar os dados presentens na requisição, execute o comando"),
      _createTextVNode(":")
    ], -1)),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _cache[6] || (_cache[6] = [
          _createTextVNode("$ openssl req -noout -text -in "),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "cert1.csr", -1)
        ]), 512)
      ]),
      _createVNode(_component_Icon, {
        class: "ms-3 m-auto",
        id: "copy-check-data-icon",
        name: "copy",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doCopy(this.$refs.checkData, 2))),
        onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetContent(2))),
        style: {"cursor":"pointer"}
      })
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_Icon, { name: "circle-check" })
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "alert__content" }, [
        _createElementVNode("div", { class: "text" }, [
          _createTextVNode("O conteúdo do arquivo "),
          _createElementVNode("strong", null, "cert1.csr"),
          _createTextVNode(" deve ser informado no campo "),
          _createElementVNode("strong", null, "CSR"),
          _createTextVNode(" .")
        ])
      ], -1))
    ])
  ]))
}